module.exports = __webpack_public_path__ + "static/media/popUp.bad732ac.jpg";